import { SEASONS, seasonOf } from "./sceneSeason";

const G = 150;
const rnd = (i, k) => { const v = Math.sin(i * 91.7 + k * 47.3) * 24634.6345; return v - Math.floor(v); };
const day = (y, m, d) => new Date(y, m, d);

const easter = (y) => {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mo = Math.floor((h + l - 7 * m + 114) / 31) - 1;
  return day(y, mo, ((h + l - 7 * m + 114) % 31) + 1);
};
const thanksgiving = (y) => { const first = day(y, 10, 1).getDay(); return day(y, 10, 1 + ((4 - first + 7) % 7) + 21); };
const shift = (d, n) => day(d.getFullYear(), d.getMonth(), d.getDate() + n);

export const HOLIDAYS = {
  newyear: { label: "New Year's", season: "winter", night: true, sky: ["#0B1433", "#24346A", "#55649C"], cloud: "#3A4A7E" },
  valentine: { label: "Valentine's", season: "winter", sky: ["#E88AA8", "#F5BFD0", "#FCE7EE"], cloud: "#FFF0F5" },
  easter: { label: "Easter", season: "spring" },
  july4: { label: "July 4th", season: "summer", night: true, sky: ["#14204D", "#4C4A8E", "#E9967A"], cloud: "#5B5A92" },
  halloween: { label: "Halloween", season: "fall", night: true, moon: true, sky: ["#22173F", "#6B3466", "#EE8A4A"], cloud: "#4A3561" },
  thanksgiving: { label: "Thanksgiving", season: "fall" },
  christmas: { label: "Christmas", season: "winter" },
};

export function holidayOf(now = new Date()) {
  const y = now.getFullYear();
  const t = day(y, now.getMonth(), now.getDate());
  const within = (a, b) => t >= a && t <= b;
  if (within(day(y, 11, 29), day(y, 11, 31)) || within(day(y, 0, 1), day(y, 0, 3))) return "newyear";
  if (within(day(y, 1, 7), day(y, 1, 14))) return "valentine";
  if (within(shift(easter(y), -7), shift(easter(y), 1))) return "easter";
  if (within(day(y, 5, 28), day(y, 6, 5))) return "july4";
  if (within(day(y, 9, 15), day(y, 9, 31))) return "halloween";
  if (within(shift(thanksgiving(y), -7), shift(thanksgiving(y), 1))) return "thanksgiving";
  if (within(day(y, 11, 1), day(y, 11, 26))) return "christmas";
  return null;
}

export function resolveTheme(choice, holidaysOn, now = new Date()) {
  if (SEASONS.includes(choice)) return { season: choice, holiday: null };
  if (HOLIDAYS[choice]) return { season: HOLIDAYS[choice].season, holiday: choice };
  const h = holidaysOn === false ? null : holidayOf(now);
  return { season: h ? HOLIDAYS[h].season : seasonOf(now), holiday: h };
}

function Burst({ x, y, c, r = 16, i, reduce }) {
  const rays = Array.from({ length: 14 }, (_, k) => { const a = (k / 14) * Math.PI * 2; return <path key={k} d={`M${x + Math.cos(a) * r * 0.35} ${y + Math.sin(a) * r * 0.35} L${x + Math.cos(a) * r} ${y + Math.sin(a) * r}`} />; });
  const d = 2.4 + (i % 3) * 0.5;
  return (
    <g stroke={c} strokeWidth="1.3" strokeLinecap="round" opacity={reduce ? 0.85 : 0} data-testid="scene-firework">
      {rays}<circle cx={x} cy={y} r="1.6" fill={c} stroke="none" />
      {!reduce && <>
        <animate attributeName="opacity" values="0;1;0.9;0" keyTimes="0;0.15;0.5;1" dur={`${d}s`} begin={`${i * 0.55}s`} repeatCount="indefinite" />
        <animateTransform attributeName="transform" type="scale" values="0.2;1;1.08" keyTimes="0;0.3;1" dur={`${d}s`} begin={`${i * 0.55}s`} repeatCount="indefinite" additive="sum" />
      </>}
    </g>
  );
}

const fireworkSpots = (top, cols) => [[-200, 0.25], [-60, 0.15], [70, 0.32], [180, 0.12], [250, 0.4], [330, 0.2], [400, 0.36]].map(([x, f], i) => ({ x, y: top + f * (G - top), c: cols[i % cols.length], i }));

function Fireworks({ top, reduce, cols }) {
  return <g data-testid="scene-fireworks">{fireworkSpots(top, cols).map((s) => (
    <g key={s.i} transform={`translate(${s.x} ${s.y})`}><Burst x={0} y={0} c={s.c} i={s.i} reduce={reduce} r={12 + (s.i % 3) * 4} /></g>
  ))}</g>;
}

export function Stars({ top }) {
  return <g data-testid="scene-stars">{Array.from({ length: 60 }, (_, i) => <circle key={i} cx={-340 + rnd(i, 1) * 780} cy={top + rnd(i, 2) * (G - top) * 0.7} r={0.4 + rnd(i, 3) * 0.8} fill="#fff" opacity={0.4 + rnd(i, 4) * 0.6} />)}</g>;
}

const heart = (x, y, s) => `M${x} ${y + 2.6 * s} C${x - 5 * s} ${y - 0.6 * s} ${x - 2.6 * s} ${y - 4.4 * s} ${x} ${y - 1.8 * s} C${x + 2.6 * s} ${y - 4.4 * s} ${x + 5 * s} ${y - 0.6 * s} ${x} ${y + 2.6 * s} Z`;

function Hearts({ top, reduce }) {
  const span = G - top;
  return <g data-testid="scene-hearts">{Array.from({ length: 24 }, (_, i) => { const x = -320 + rnd(i, 1) * 740; const d = 9 + rnd(i, 2) * 6; const y = reduce ? top + rnd(i, 3) * span : G; return (
    <path key={i} d={heart(x, y, 0.7 + rnd(i, 4) * 0.7)} fill={["#FF4F7B", "#FF8FAB", "#E0245E", "#FFFFFF"][i % 4]} opacity="0.85">
      {!reduce && <animateTransform attributeName="transform" type="translate" values={`0 0;${(rnd(i, 5) - 0.5) * 30} ${-span}`} dur={`${d}s`} begin={`-${rnd(i, 6) * d}s`} repeatCount="indefinite" />}
    </path>
  ); })}</g>;
}

function Bats({ top, reduce }) {
  return <g data-testid="scene-bats">{[[0, 0.2, 13], [40, 0.32, 16], [90, 0.14, 19], [150, 0.26, 15]].map(([dx, f, d], i) => (
    <path key={i} d={`M${-320 + dx} ${top + f * (G - top)} q2 -3 4 -1 q1 -2 2 0 q1 -2 2 0 q2 -2 4 1 q-3 -1 -4 1 q-1 -1 -2 0 q-1 -1 -2 0 q-1 -2 -4 -1 Z`} fill="#1A1026">
      {!reduce && <animateTransform attributeName="transform" type="translate" values={`0 0;380 -12;760 4`} dur={`${d}s`} begin={`-${i * 4}s`} repeatCount="indefinite" />}
    </path>
  ))}</g>;
}

export function HolidaySky({ holiday, top, reduce }) {
  if (!holiday) return null;
  const at = (f) => top + f * (G - top);
  return (
    <g data-testid={`scene-holiday-${holiday}`}>
      {HOLIDAYS[holiday].night && <Stars top={top} />}
      {HOLIDAYS[holiday].moon && <g data-testid="scene-moon"><circle cx="250" cy={at(0.28)} r="22" fill="#FFE7A8" opacity="0.18" /><circle cx="250" cy={at(0.28)} r="12" fill="#FFF1C4" /><circle cx="246" cy={at(0.25)} r="2" fill="#E9D49A" /><circle cx="254" cy={at(0.31)} r="1.4" fill="#E9D49A" /></g>}
      {holiday === "newyear" && <Fireworks top={top} reduce={reduce} cols={["#FFD60A", "#FFFFFF", "#64D2FF", "#FF9F0A"]} />}
      {holiday === "july4" && <Fireworks top={top} reduce={reduce} cols={["#FF453A", "#FFFFFF", "#0A84FF"]} />}
      {holiday === "valentine" && <Hearts top={top} reduce={reduce} />}
      {holiday === "halloween" && <Bats top={top} reduce={reduce} />}
      {holiday === "christmas" && <SantaSleigh top={top} reduce={reduce} />}
    </g>
  );
}

const Egg = ({ x, c, s = 1 }) => <g><ellipse cx={x} cy={G - 3.4 * s} rx={2.6 * s} ry={3.4 * s} fill={c} /><path d={`M${x - 2.4 * s} ${G - 3.6 * s} q1.2 -1 2.4 0 t2.4 0`} stroke="#fff" strokeWidth="0.7" fill="none" /></g>;

function Bunny({ x, reduce }) {
  return (
    <g data-testid="scene-bunny"><g>
      {!reduce && <animateTransform attributeName="transform" type="translate" values="0 0;5 -6;10 0;10 0;5 -6;0 0;0 0" keyTimes="0;0.1;0.2;0.5;0.6;0.7;1" dur="3.2s" repeatCount="indefinite" />}
      <ellipse cx={x} cy={G - 5} rx="6" ry="5" fill="#F4F1EC" /><circle cx={x + 5} cy={G - 10} r="3.6" fill="#F4F1EC" />
      <ellipse cx={x + 4} cy={G - 17} rx="1.2" ry="4" fill="#F4F1EC" /><ellipse cx={x + 6.6} cy={G - 16.6} rx="1.2" ry="4" fill="#F4F1EC" transform={`rotate(14 ${x + 6.6} ${G - 16.6})`} />
      <ellipse cx={x + 4} cy={G - 17} rx="0.5" ry="2.6" fill="#FFB3C7" /><circle cx={x + 6.6} cy={G - 10.6} r="0.7" fill="#2B2B2B" /><circle cx={x + 8.4} cy={G - 9.4} r="0.6" fill="#FF8FAB" />
      <circle cx={x - 6} cy={G - 6} r="1.8" fill="#fff" />
    </g></g>
  );
}

function Turkey({ x }) {
  return (
    <g data-testid="scene-turkey">
      {["#8B3A1A", "#C2621F", "#E39A2D", "#C2621F", "#8B3A1A"].map((c, i) => <ellipse key={i} cx={x - 2 + (i - 2) * 3.2} cy={G - 15 + Math.abs(i - 2) * 1.8} rx="2.4" ry="7" fill={c} transform={`rotate(${(i - 2) * 22} ${x - 2} ${G - 8})`} />)}
      <ellipse cx={x} cy={G - 7} rx="6" ry="5.5" fill="#6B3A1E" /><circle cx={x + 4.5} cy={G - 13} r="2.8" fill="#8A5A3A" />
      <path d={`M${x + 7} ${G - 13} l2 0.8 l-2 0.8 Z`} fill="#F5B300" /><path d={`M${x + 6.6} ${G - 12} q1 3 -0.4 4`} stroke="#E0242B" strokeWidth="1.2" fill="none" />
      <circle cx={x + 5} cy={G - 13.6} r="0.6" fill="#1B1B1B" /><path d={`M${x - 1} ${G - 2} v2 M${x + 2} ${G - 2} v2`} stroke="#F5B300" strokeWidth="1" />
    </g>
  );
}

function Ghost({ x, reduce }) {
  return (
    <g data-testid="scene-ghost" opacity="0.92"><g>
      {!reduce && <animateTransform attributeName="transform" type="translate" values="0 0;0 -4;0 0" dur="3s" repeatCount="indefinite" />}
      <path d={`M${x - 7} ${G - 10} V${G - 22} A7 7 0 0 1 ${x + 7} ${G - 22} V${G - 10} l-2.4 -2 l-2.3 2 l-2.3 -2 l-2.3 2 l-2.3 -2 Z`} fill="#F7F7FA" />
      <ellipse cx={x - 2.4} cy={G - 21} rx="1" ry="1.5" fill="#2B2B2B" /><ellipse cx={x + 2.4} cy={G - 21} rx="1" ry="1.5" fill="#2B2B2B" /><ellipse cx={x} cy={G - 17} rx="1.4" ry="1" fill="#2B2B2B" />
    </g></g>
  );
}

function Snowman({ x }) {
  return (
    <g data-testid="scene-snowman">
      <circle cx={x} cy={G - 7} r="7.5" fill="#fff" stroke="#DCE3EA" strokeWidth="0.6" /><circle cx={x} cy={G - 18.5} r="5.2" fill="#fff" stroke="#DCE3EA" strokeWidth="0.6" />
      <rect x={x - 4.6} y={G - 24.6} width="9.2" height="1.6" fill="#1B1B1B" /><rect x={x - 3} y={G - 30} width="6" height="5.6" fill="#1B1B1B" />
      <circle cx={x - 1.8} cy={G - 19.6} r="0.6" fill="#1B1B1B" /><circle cx={x + 1.8} cy={G - 19.6} r="0.6" fill="#1B1B1B" /><path d={`M${x} ${G - 18} l4 1 l-4 0.8 Z`} fill="#FF8A1F" />
      <rect x={x - 5} y={G - 14.6} width="10" height="2.2" rx="1" fill="#E0242B" /><path d={`M${x + 6} ${G - 10} l8 -6 M${x - 6} ${G - 10} l-8 -6`} stroke="#6B4A2E" strokeWidth="1" />
    </g>
  );
}

const Gift = ({ x, w, h, c, r }) => <g><rect x={x - w / 2} y={G - h} width={w} height={h} rx="0.8" fill={c} /><path d={`M${x} ${G - h} V${G} M${x - w / 2} ${G - h / 2} H${x + w / 2}`} stroke={r} strokeWidth="1.2" /><path d={`M${x} ${G - h} q-3 -3 -3.6 0 Z M${x} ${G - h} q3 -3 3.6 0 Z`} fill={r} /></g>;

const LIGHTS = ["#FF453A", "#FFD60A", "#64D2FF", "#30D158", "#FF9F0A"];

function PineTree({ x, h, reduce, star, k = 0 }) {
  const w = h * 0.62;
  const tiers = [0, 0.3, 0.56].map((f, i) => {
    const y0 = G - h * 0.12 - f * h * 0.82, tw = w * (1 - i * 0.24), th = h * 0.42;
    return <path key={i} d={`M${x - tw / 2} ${y0} L${x} ${y0 - th} L${x + tw / 2} ${y0} Z`} fill={["#1E5B35", "#226A3D", "#287846"][i]} />;
  });
  const lights = Array.from({ length: 11 }, (_, i) => {
    const f = (i + 0.5) / 11, y = G - h * 0.16 - f * h * 0.72, half = (w / 2) * (1 - f * 0.86) * 0.82;
    return { x: x + (i % 2 ? half : -half) * (0.35 + rnd(i + k, 5) * 0.65), y, c: LIGHTS[(i + k) % LIGHTS.length], i };
  });
  return (
    <g data-testid="scene-pine-tree">
      <rect x={x - 1.6} y={G - h * 0.13} width="3.2" height={h * 0.13} fill="#6B4A2E" />
      {tiers}
      <path d={lights.map((l, i) => `${i ? "L" : "M"}${l.x} ${l.y}`).join(" ")} stroke="#FFF4C2" strokeOpacity="0.35" strokeWidth="0.4" fill="none" />
      {lights.map((l) => (
        <circle key={l.i} cx={l.x} cy={l.y} r="1.15" fill={l.c} data-testid="scene-tree-light">
          {!reduce && <animate attributeName="opacity" values="1;0.35;1" dur={`${1.4 + (l.i % 3) * 0.45}s`} begin={`${(l.i * 0.23) % 1.2}s`} repeatCount="indefinite" />}
        </circle>
      ))}
      {star && <path d={`M${x} ${G - h * 1.06} l1.3 2.6 l2.8 0.3 l-2.1 1.9 l0.6 2.8 l-2.6 -1.4 l-2.6 1.4 l0.6 -2.8 l-2.1 -1.9 l2.8 -0.3 Z`} fill="#FFD60A" />}
    </g>
  );
}

function Reindeer({ x, y, nose }) {
  return (
    <g>
      <ellipse cx={x} cy={y} rx="5.2" ry="2.3" fill="#8A5A3A" />
      <path d={`M${x + 4} ${y - 1} l2.6 -3.4`} stroke="#8A5A3A" strokeWidth="1.6" strokeLinecap="round" />
      <ellipse cx={x + 7.4} cy={y - 4.6} rx="2" ry="1.4" fill="#8A5A3A" />
      <path d={`M${x + 6.6} ${y - 5.6} l-1 -2.6 m0.5 1.2 l-1.4 0.2 M${x + 7.8} ${y - 5.8} l0.6 -2.6 m-0.3 1.2 l1.3 -0.4`} stroke="#5C3A1E" strokeWidth="0.6" strokeLinecap="round" fill="none" />
      {nose && <circle cx={x + 9.4} cy={y - 4.4} r="0.9" fill="#FF3B30" />}
      <path d={`M${x - 3.6} ${y + 1.6} l-2.4 2 M${x - 2} ${y + 1.8} l-0.6 2.6 M${x + 2.4} ${y + 1.8} l1.6 2.2 M${x + 3.8} ${y + 1.4} l2.6 1.4`} stroke="#6B4A2E" strokeWidth="0.8" strokeLinecap="round" />
    </g>
  );
}

function SantaSleigh({ top, reduce }) {
  const y = top + (G - top) * 0.2;
  const body = (
    <g data-testid="scene-santa">
      <path d={`M-14 ${y - 3} Q14 ${y - 3} 26 ${y - 10}`} stroke="#C9A227" strokeWidth="0.5" fill="none" />
      <Reindeer x={30} y={y - 9} /><Reindeer x={45} y={y - 13} /><Reindeer x={60} y={y - 17} nose />
      <path d={`M-20 ${y - 4} h15 q4 0 5 -5 l1.2 -3 M-22 ${y + 1} q3 2.4 7 2.4 h15 q3 0 4 -2`} stroke="#C9A227" strokeWidth="0.9" fill="none" strokeLinecap="round" />
      <path d={`M-20 ${y - 4} q-2 -7 2 -9 h12 q3 0 3 3 v6 Z`} fill="#D7262E" />
      <circle cx="-12" cy={y - 15.5} r="3" fill="#F2C9A5" />
      <path d={`M-15 ${y - 13.6} q3 4.4 6 0 q-3 1.4 -6 0 Z`} fill="#fff" />
      <path d={`M-15.4 ${y - 16.4} q3 -6 7 -1 Z`} fill="#D7262E" /><circle cx="-8.2" cy={y - 17} r="0.9" fill="#fff" />
      <path d={`M-16 ${y - 11} h8 v4 h-8 Z`} fill="#B51E25" />
      <path d={`M-19 ${y - 13} q-3 -4 1 -6 q3 2 1 6 Z`} fill="#8E5A2B" />
    </g>
  );
  if (reduce) return <g transform="translate(60 0)">{body}</g>;
  return (
    <g>
      <animateTransform attributeName="transform" type="translate" values="-40 18;470 -8" dur="14s" repeatCount="indefinite" />
      <g><animateTransform attributeName="transform" type="translate" values="0 0;0 -3;0 0" dur="2.2s" repeatCount="indefinite" />{body}</g>
    </g>
  );
}

export function HolidayGround({ holiday, reduce }) {
  if (!holiday) return null;
  if (holiday === "christmas") return <g data-testid="scene-holiday-ground"><PineTree x={286} h={62} reduce={reduce} star /><PineTree x={404} h={54} reduce={reduce} k={4} /><PineTree x={52} h={48} reduce={reduce} k={2} /><Snowman x={121} /><Gift x={326} w={8} h={7} c="#E0242B" r="#FFD60A" /><Gift x={364} w={7} h={9} c="#2F7A45" r="#fff" /><Gift x={377} w={6} h={6} c="#0A84FF" r="#fff" /></g>;
  if (holiday === "easter") return <g data-testid="scene-holiday-ground">{[[108, "#FFE27A"], [86, "#9AD8FF"], [126, "#B9F2A1"], [214, "#D7B8FF"], [326, "#FF8FAB"], [366, "#FFE27A"], [382, "#9AD8FF"]].map(([x, c]) => <Egg key={x} x={x} c={c} />)}<Bunny x={112} reduce={reduce} /></g>;
  if (holiday === "thanksgiving") return <g data-testid="scene-holiday-ground"><Turkey x={120} /></g>;
  if (holiday === "halloween") return <g data-testid="scene-holiday-ground"><Ghost x={122} reduce={reduce} /></g>;
  if (holiday === "valentine") return (
    <g data-testid="scene-holiday-ground">
      <path d={heart(345, 106, 1.5)} fill="#E0245E" />
      {[[147, 70, "#FF4F7B"], [158, 64, "#E0245E"]].map(([x, y, c]) => <g key={x}><path d={`M${x} ${y + 4} Q${x + 2} ${y + 20} 152 ${G - 46}`} stroke="#9AA0A6" strokeWidth="0.5" fill="none" /><path d={heart(x, y, 1.6)} fill={c} /></g>)}
    </g>
  );
  if (holiday === "july4") return (
    <g data-testid="scene-holiday-ground">
      <path d="M345 60 V36" stroke="#8E8E93" strokeWidth="1" />
      <g data-testid="scene-flag">{[0, 1, 2, 3, 4, 5, 6].map((i) => <rect key={i} x="345.5" y={36 + i * 1.6} width="17" height="1.6" fill={i % 2 ? "#fff" : "#E0242B"} />)}<rect x="345.5" y="36" width="7" height="6.4" fill="#1D3E8A" /></g>
    </g>
  );
  if (holiday === "newyear") return (
    <g data-testid="scene-holiday-ground"><path d="M300 93 Q345 103 390 93" stroke="#FFD60A" strokeWidth="1.2" fill="none" strokeDasharray="2 2" /><text x="345" y="51" textAnchor="middle" fontSize="9" fontWeight="800" fill="#FFD60A" fontFamily="inherit">{new Date().getMonth() === 11 ? new Date().getFullYear() + 1 : new Date().getFullYear()}</text></g>
  );
  return null;
}
